import type { DBTypes } from '@openphone/dexie-database/types'
import { makeAutoObservable, toJS } from 'mobx'

import type { Model } from '@src/service/model/base'

export type RawWorkflowDefinitionCriteriaType =
  DBTypes.WorkflowDefinitionCriteriaTypeGroup

export default class WorkflowDefinitionCriteriaTypeModel implements Model {
  private raw: RawWorkflowDefinitionCriteriaType

  get id() {
    return this.raw.conditionId
  }

  get conditionId() {
    return this.raw.conditionId
  }

  get type() {
    return this.raw.type
  }

  get supportedFilterDefinitionIds() {
    return this.raw.supportedFilterDefinitionIds
  }

  constructor(attrs: RawWorkflowDefinitionCriteriaType) {
    this.raw = attrs

    makeAutoObservable<this>(this)
  }

  deserialize(json: RawWorkflowDefinitionCriteriaType): this {
    this.raw = json
    return this
  }

  serialize(): RawWorkflowDefinitionCriteriaType {
    return toJS(this.raw)
  }
}
